<template>
  <div class="configStatusLevelVue">
    <div class="col-md-10 col-sm-9 u-pad-all-25 c-common-box-shadow u-bg-color-fff">
        <div class="status-level">

            <h3 class="">Status Levels
                <span class="c-common-btn--inverse-icon-orange">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </span>
                <a href="javascript: void(0)" @click="addNewStatus()" class="c-common-btn c-common-btn--green">
                    <i class="fa fa-plus" aria-hidden="true"></i> Add Status Manager
                </a>
            </h3>

            <div class="row">
                <div class="col-md-8 u-margin-20">
                    <div class="panel-group" id="accordion">

                        <div class="panel panel-default o-accordion-area c-common-box-shadow" v-for="(status,key) in status_list" :key="key">
                            <div class="o-accordion-heading c-common-gradient  clearfix status-level-heading">

                                <div class="col-md-9 col-sm-9 u-no-padding">
                                    <a href="javascript: void(0)" data-toggle="collapse" data-parent="#accordion" :href="'#collapse'+key" class="js-accordion-triger ps2 u-no-margin u-padding-all-20">{{status.name +" ("+status.employees.length+")"}}  </a>
                                </div>
                                <div class="col-md-3 col-sm-3 text-right o-uploaded-doc-owner u-padding-all-10">
                                    <h5>
                                        <a href="javascript: void(0)" class="o-config-edit" @click="editNewStatus(status)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                        <a v-if="status.name!='NEW REGISTRANT'" href="javascript: void(0)" @click="deleteStatus(status.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                    </h5>
                                </div>
                            </div>

                            <div :class="{'clearfix' :true, 'status-level-details' :true, 'panel-Seven' :true, 'collapse':true ,'in':(key == 0)?true:false}" :id="'collapse'+key">
                                <div class="blue-bg clearfix">
                                    <div class="col-sm-12 ps2"><span>Status: </span>{{status.name}}</div>

                                </div>
                                <div class="white-bg clearfix">
                                    <div class="col-sm-12 ps2 u-no-margin u-padding-all-20 ex-list">
                                        <div class="status">
                                            <strong>Priority</strong> {{(status.priority != "")?status.priority:0}}
                                        </div>
                                        <div class="status">
                                            <strong>Able to work?</strong> {{(status.able_to_work == 1)?'Yes':'No'}}
                                        </div>
                                        <div class="status">
                                            <strong>Stewards List?</strong> {{(status.stewards_list == 1)?'Yes':'No'}}
                                        </div>
                                        <div class="status">
                                            <strong>Able to Login?</strong> {{(status.able_to_login == 1)?'Yes':'No'}}
                                        </div>
                                        <div class="status">
                                            <strong>Show Notify and Action Log?</strong> {{(status.able_to_access_logs == 1)?'Yes':'No'}}
                                        </div>
                                        <div class="status">
                                            <strong>Block Job Notification?</strong> {{(status.block_job_notifications == 1)?'Yes':'No'}}
                                        </div>
                                        
                                        <div class="status">
                                            <strong>Track Last Offer?</strong> {{(status.last_offer == 1)?'Yes':'No'}}
                                        </div>
                                        <div class="status">
                                            <strong>Color</strong> <span :style="{'background-color': status.link_color}" class="status-color-picker"></span>
                                        </div>
                                        <div class="status">
                                            <strong>Block External MUA Booking / Other Booking?</strong> {{(status.block_mua_bookings == 1)?'Yes':'No'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <modal name="add-new-status"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
        <div id="" class="modal-add-call" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button @click="closeNewStatus()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">{{statusDetails.status_action}} Status Level</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Status:</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                <div class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Enter status name" v-model="statusDetails.name">
                                    <span class="err-msg" v-show="err_message == 1">Please enter status name</span>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Priority:</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" class="form-control" placeholder="Enter priority" v-model="statusDetails.priority">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Able to work?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o3" :value="1" v-model="statusDetails.able_to_work">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o3" :value="0" v-model="statusDetails.able_to_work">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Show in StewardsList?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o4" :value="1" v-model="statusDetails.stewards_list">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o4" :value="0" v-model="statusDetails.stewards_list">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Able to Login ?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o5" :value="1" v-model="statusDetails.able_to_login">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o5" :value="0" v-model="statusDetails.able_to_login">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Show Notify and Action Log?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o6" :value="1" v-model="statusDetails.able_to_access_logs">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o6" :value="0" v-model="statusDetails.able_to_access_logs">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Block Job Notification?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o7" :value="1" v-model="statusDetails.block_job_notifications">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o7" :value="0" v-model="statusDetails.block_job_notifications">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Track Last Offer?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o8" :value="1" v-model="statusDetails.last_offer">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o8" :value="0" v-model="statusDetails.last_offer">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Color </label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <el-color-picker v-model="statusDetails.link_color"></el-color-picker>
                                    <!-- <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o7" :value="1" v-model="statusDetails.block_job_notifications">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o7" :value="0" v-model="statusDetails.block_job_notifications">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                    <label class="common-label-text common-label-text--modalwidth">Block External MUA Booking / Other Booking?</label>
                                </div>
                                <div class="col-sm-8 o-left-no-padding o-modal-form-field">
                                    <div class="common-label-input--modalwidth o-custom-dropdown">
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o9" :value="1" v-model="statusDetails.block_mua_bookings">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o9" :value="0" v-model="statusDetails.block_mua_bookings">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeNewStatus()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="saveStatus()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> {{statusDetails.status_action}} Status level</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </modal>
  </div>
</template>
<script>
  import {
      mapGetters,
      mapActions
  } from 'vuex';
  import {
      global
  } from '../../global.js';
  import service from '../../services.js';
    export default {
        data() {
            return {
              statusDetails : {
                name : '',
                priority : '',
                able_to_work :1,
                stewards_list : 0,
                able_to_login:1,
                able_to_access_logs:1,
                block_job_notifications:0,
                status_action : 'Add',
                client_id : '',
                employee_status_id : 0,
                last_offer: 1,
                link_color:"#4D7FAE",
                block_mua_bookings: 0
              },
              err_message : 0,
              status_list : []

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID"
            }),
            sortedStatus(){

            }
        },
        methods: {
            addNewStatus() {
                // this.statusDetails.status_action = 'Add';
                // this.statusDetails.client_id = this.userClientID;
                this.statusDetails={
                    name : '',
                    priority : '',
                    able_to_work :1,
                    stewards_list : 0,
                    status_action : 'Add',
                    able_to_login:1,
                    able_to_access_logs:1,
                    block_job_notifications:0,
                    block_mua_bookings:0,
                    client_id : this.userClientID,
                    employee_status_id : 0,
                    link_color:"#4D7FAE",
                },
                this.$modal.show("add-new-status");
            },
            closeNewStatus() {
                this.$modal.hide("add-new-status");
            },
            editNewStatus(status) {
                this.statusDetails.status_action = 'Edit';
                this.statusDetails.name = status.name;
                this.statusDetails.priority = status.priority;
                this.statusDetails.able_to_work = status.able_to_work;
                this.statusDetails.stewards_list = status.stewards_list;
                this.statusDetails.able_to_login= status.able_to_login;
                this.statusDetails.able_to_access_logs = status.able_to_access_logs;
                this.statusDetails.block_job_notifications= status.block_job_notifications;
                this.statusDetails.block_mua_bookings = status.block_mua_bookings?status.block_mua_bookings:0;
                this.statusDetails.client_id = this.userClientID;
                this.statusDetails.employee_status_id = status.id;
                this.statusDetails.link_color = status.link_color;
                this.$modal.show("add-new-status");
            },
            saveStatus()
            {
              if(this.statusDetails.name == '')
              {
                this.err_message = 1;
              }
              else {
                   this.err_message = 0;
                   //console.log(this.statusDetails);
                   if(this.statusDetails.status_action == 'Add')
                   {
                     service.post('employee/addEmployeeStatus', this.statusDetails, {
                             'Authorization': this.userToken,
                             'cs3-context-role': this.userRole,
                             'cs3-context-clientId': this.userClientID
                         })
                         .then((res) => {
                           this.$notify({
                             title: this.$t('success'),
                             message: 'Status Added Successfully.',
                             type: 'success'
                           });
                           this.statusList();
                           this.closeNewStatus();
                         }).catch((err) => {
                           this.$notify.error({
                               title: this.$t('error'),
                               message: 'Something went wrong!'
                           });
                         });
                   }
                   else {
                     service.post('employee/editEmployeeStatus', this.statusDetails, {
                             'Authorization': this.userToken,
                             'cs3-context-role': this.userRole,
                             'cs3-context-clientId': this.userClientID
                         })
                         .then((res) => {
                           this.$notify({
                             title: this.$t('success'),
                             message: 'Status Updated Successfully.',
                             type: 'success'
                           });
                           this.statusList();
                           this.closeNewStatus();

                         }).catch((err) => {
                           this.$notify.error({
                               title: this.$t('error'),
                               message: 'Something went wrong!'
                           });
                         });
                   }
              }


            },
            statusList()
            {
              service.get('employee/employee_status', {
                      'Authorization': this.userToken,
                      'cs3-context-role': this.userRole,
                      'cs3-context-clientId': this.userClientID
                  })
                  .then((res) => {

                    this.status_list = res.data.result; 

                    this.status_list.sort(function(a, b) {

                        if (Number(a.priority) < Number(b.priority)) return -1;
                        if (Number(a.priority) > Number(b.priority)) return 1;
                        return 0;
                    });
                    //console.log(this.status_list);

                  }).catch((err) => {

                  });
            },
            deleteStatus(id)
            {
              this.$confirm('Status will be deleted. Continue?', 'Warning', {
                  confirmButtonText: 'OK',
                  cancelButtonText: 'Cancel',
                  type: 'warning'
              }).then(() => {
                  service.post('employee/deleteEmployeeStatus' ,{'employee_status_id':id}, {
                      'Authorization': this.userToken

                  }).
                  then((res) => {
                      this.statusList();
                      this.$message({
                          type: 'success',
                          message: 'Delete completed'
                      });
                  }).catch((err) => {
                      console.log(err);
                  });
              }).catch(() => {
                  this.$message({
                      type: 'info',
                      message: 'Delete canceled'
                  });
              });
            }

        },
        created()
        {
          this.statusList();
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/configuration/configStatusLevel.vue